import React, { useState, useEffect } from 'react';
import {
    adminLogin,
    blockUser,
    createSlots,
    getAllSlots,
    getAllUsers,
    unblockUser,
    fetchAdminMe,
    getLeadersForAssign,
    assignSlotsToAdmin,
    patchSlot,
} from './adminApi';
import AnketaModal from './AnketaModal';
import './Admin.css'
import Presentation from './Presentation';
import Media from './Media';
import Hosts from './Hosts';
import { useNavigate } from 'react-router-dom';
import { bookSlot } from '../Slots/slotsApi';
import { sendAuthRequest } from '../Auth/authApi';

const formatDate = (isoString) => {
    const date = new Date(isoString);
    return (
        date.toLocaleDateString('ru-RU', {
            weekday: 'short',
            day: '2-digit',
            month: '2-digit',
        }) +
        ' ' +
        date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
    );
};

const Admin = () => {
    const navigate = useNavigate()
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState('');
    const [loginField, setLoginField] = useState('');
    const [session, setSession] = useState(null);
    const [activeTab, setActiveTab] = useState(() => {
        try {
            const raw = localStorage.getItem('adminSession');
            if (!raw) return 'slots';
            const s = JSON.parse(raw);
            if (s.role === 'host' && !s.access_slots && s.access_media) return 'media';
        } catch (e) {
            /* ignore */
        }
        return 'slots';
    });
    const [slots, setSlots] = useState([]);
    const [users, setUsers] = useState([]);

    const [photosArr, setPhotosArr] = useState([]);

    const [showAddInput, setShowAddInput] = React.useState(false);
    const [newSlotDate, setNewSlotDate] = React.useState('');

    const [showPastSlots, setShowPastSlots] = useState(false);

    const [selectedSlotIds, setSelectedSlotIds] = useState([]);
    const [assignModalOpen, setAssignModalOpen] = useState(false);
    const [leaders, setLeaders] = useState([]);
    const [selectedLeaderId, setSelectedLeaderId] = useState('');
    const [assignSaving, setAssignSaving] = useState(false);

    const [selectedSlot, setSelectedSlot] = useState(null);


    const [modalAnketa, setModalAnketa] = useState(null);
    const weekdayColors = {
        1: '#a3260b', // Понедельник
        2: '#33A1FF', // Вторник
        3: '#28B463', // Среда
        4: '#FFC300', // Четверг
        5: '#9B59B6'  // Пятница
    };


    const applySession = (s) => {
        setSession(s);
        if (s.role === 'host' && !s.access_slots && s.access_media) {
            setActiveTab('media');
        }
    };

    const handleAuth = async () => {
        try {
            const res = await adminLogin(password, loginField);
            if (res.success && res.token) {
                localStorage.setItem('adminToken', res.token);
                const sess = {
                    role: res.role,
                    access_media: res.access_media,
                    access_slots: res.access_slots,
                };
                localStorage.setItem('adminSession', JSON.stringify(sess));
                applySession(sess);
                setIsAuthenticated(true);
            } else {
                alert('Ошибка входа');
            }
        } catch (error) {
            alert(error.message || 'Ошибка авторизации');
        }
    };

    const toggleSlotSelected = (slotId) => {
        setSelectedSlotIds((prev) =>
            prev.includes(slotId) ? prev.filter((id) => id !== slotId) : [...prev, slotId]
        );
    };

    const openAssignModal = async () => {
        if (selectedSlotIds.length === 0) return;
        setAssignModalOpen(true);
        setSelectedLeaderId('');
        try {
            const data = await getLeadersForAssign();
            setLeaders(data.leaders || []);
        } catch (e) {
            console.error(e);
            alert(e.message || 'Не удалось загрузить список ведущих');
        }
    };

    const confirmAssign = async () => {
        if (selectedLeaderId === '') {
            alert('Выберите ведущего');
            return;
        }
        setAssignSaving(true);
        try {
            await assignSlotsToAdmin(selectedSlotIds, parseInt(selectedLeaderId, 10));
            setAssignModalOpen(false);
            setSelectedSlotIds([]);
            const data = await getAllSlots();
            const slotsWithFormattedDate = data.slots.map((slot) => ({
                ...slot,
                formattedDate: formatDate(slot.datetime),
            }));
            setSlots(slotsWithFormattedDate);
        } catch (e) {
            alert(e.message || 'Ошибка');
        } finally {
            setAssignSaving(false);
        }
    };

    const toggleSlotHidden = async (slot, e) => {
        e.stopPropagation();
        const next = slot.slot_status === 'hidden' ? 'open' : 'hidden';
        try {
            await patchSlot(slot.id, { status: next });
            setSlots((prev) =>
                prev.map((s) =>
                    s.id === slot.id ? { ...s, slot_status: next } : s
                )
            );
        } catch (err) {
            alert(err.message || 'Ошибка');
        }
    };

    // async function handleBlockUser(userId) {

    //     try {
    //         await blockUser(userId);
    //         alert('Пользователь заблокирован');
    //         // при необходимости обновите список пользователей
    //     } catch (error) {
    //         console.error('Ошибка блокировки:', error);
    //         alert('Не удалось заблокировать пользователя');
    //     }

    // }
    async function handleBlockUser(userId) {
        try {
            await blockUser(userId);
            alert('Пользователь заблокирован');

            // Обновляем статус пользователя в списке локально
            setUsers((prevUsers) =>
                prevUsers.map((user) =>
                    user.id === userId ? { ...user, status: 'block' } : user
                )
            );
        } catch (error) {
            console.error('Ошибка блокировки:', error);
            alert('Не удалось заблокировать пользователя');
        }
    }

    async function handleUnblockUser(userId) {
        try {
            await unblockUser(userId);
            alert('Пользователь разблокирован');

            // Обновляем статус пользователя в списке локально
            setUsers((prevUsers) =>
                prevUsers.map((user) =>
                    user.id === userId ? { ...user, status: 'active' } : user
                )
            );
        } catch (error) {
            console.error('Ошибка разблокировки:', error);
            alert('Не удалось разблокировать пользователя');
        }
    }

    const handleCloseAnket = () => {
        setModalAnketa(null)
        getAllSlots()
            .then((data) => {
                const slotsWithFormattedDate = data.slots.map((slot) => ({
                    ...slot,
                    formattedDate: formatDate(slot.datetime),
                }));
                console.log('slotsWithFormattedDate', slotsWithFormattedDate)
                setSlots(slotsWithFormattedDate);
            })
            .catch(console.error);
    }

    const handleBookAnketaClick = async (slot) => {
        const email = prompt('Введите email пользователя для бронирования:');
        if (!email) return;

        const password = '12345';
        const name = email.split('@')[0];

        try {
            // Регистрируем пользователя
            const result = await sendAuthRequest({
                email,
                password,
                mode: 'register',
                name,
            });

            if (!result.user) {
                alert('Не удалось зарегистрировать пользователя');
                return;
            }

            // Бронируем слот
            const booking = await bookSlot(slot.id, email);
            const enrichedSlot = { ...slot, anket_id: booking.anketId };

            navigate('/anketa', { state: { slot: enrichedSlot } });
        } catch (err) {
            alert(`Ошибка: ${err.message}`);
        }
    };

    const handleClickAnket = (anketa) => {
        console.log('handleClickAnket', anketa, anketa?.photos)
        if (anketa?.photos) {
            console.log('handleClickAnket photos', anketa?.photos)
            setPhotosArr(anketa.photos.split('|'));
        }
        else setPhotosArr([])
        setModalAnketa(anketa)
    }


    useEffect(() => {
        if (!isAuthenticated) return;

        if (activeTab === 'slots') {
            getAllSlots()
                .then((data) => {
                    const slotsWithFormattedDate = data.slots.map((slot) => ({
                        ...slot,
                        formattedDate: formatDate(slot.datetime),
                    }));
                    console.log('slotsWithFormattedDate', slotsWithFormattedDate)
                    setSlots(slotsWithFormattedDate);
                })
                .catch(console.error);
        } else if (activeTab === 'users') {
            getAllUsers().then(setUsers).catch(console.error);
        }
    }, [activeTab, isAuthenticated]);

    useEffect(() => {
        const token = localStorage.getItem('adminToken');
        if (!token) return;
        fetchAdminMe()
            .then((s) => {
                localStorage.setItem(
                    'adminSession',
                    JSON.stringify({
                        role: s.role,
                        access_media: s.access_media,
                        access_slots: s.access_slots,
                    })
                );
                applySession(s);
                setIsAuthenticated(true);
            })
            .catch(() => {
                localStorage.removeItem('adminToken');
                localStorage.removeItem('adminSession');
            });
    }, []);


    if (!isAuthenticated) {
        return (
            <div style={{ padding: '20px' }}>
                <h2>Вход администратора</h2>
                <p style={{ fontSize: 14, color: '#666', marginBottom: 12 }}>
                    Главный админ: только пароль из настроек сервера. Ведущий: логин и пароль.
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 320 }}>
                    <input
                        className='input_password'
                        type="text"
                        placeholder="Логин (для ведущего; для главного оставьте пустым)"
                        value={loginField}
                        onChange={(e) => setLoginField(e.target.value)}
                    />
                    <input
                        className='input_password'
                        type="password"
                        placeholder="Пароль"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <button type="button" className='btn_admin' onClick={handleAuth} style={{ alignSelf: 'flex-start' }}>Войти</button>
                </div>
            </div>
        );
    }

    const isSuper = session?.role === 'super';
    const canSlots = isSuper || session?.access_slots;
    const canMedia = isSuper || session?.access_media;

    return (
        <>
            {selectedSlot ?
                <Presentation
                    slot={selectedSlot}
                    onClose={() => setSelectedSlot(null)}
                />
                :
                <div style={{ padding: '20px' }}>
                    <h2>Админ-панель</h2>

                    <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {canSlots && (
                        <button
                            type="button"
                            onClick={() => setActiveTab('slots')}
                            style={{
                                backgroundColor: activeTab === 'slots' ? '#48b8c7' : '#ccc',
                                padding: '8px 16px',
                                borderRadius: '5px',
                                border: 'none',
                                color: '#fff',
                                cursor: 'pointer',
                            }}
                        >
                            Слоты
                        </button>
                        )}

                        {canSlots && (
                        <button
                            type="button"
                            onClick={() => setActiveTab('users')}
                            style={{
                                backgroundColor: activeTab === 'users' ? '#48b8c7' : '#ccc',
                                padding: '8px 16px',
                                borderRadius: '5px',
                                border: 'none',
                                color: '#fff',
                                cursor: 'pointer',
                            }}
                        >
                            Пользователи
                        </button>
                        )}

                        {canMedia && (
                        <button
                            type="button"
                            onClick={() => setActiveTab('media')}
                            style={{
                                backgroundColor: activeTab === 'media' ? '#48b8c7' : '#ccc',
                                padding: '8px 16px',
                                borderRadius: '5px',
                                border: 'none',
                                color: '#fff',
                                cursor: 'pointer',
                            }}
                        >
                            Медиа
                        </button>
                        )}

                        {isSuper && (
                        <button
                            type="button"
                            onClick={() => setActiveTab('hosts')}
                            style={{
                                backgroundColor: activeTab === 'hosts' ? '#48b8c7' : '#ccc',
                                padding: '8px 16px',
                                borderRadius: '5px',
                                border: 'none',
                                color: '#fff',
                                cursor: 'pointer',
                            }}
                        >
                            Ведущие
                        </button>
                        )}
                    </div>

                    {activeTab === 'slots' &&
                        <>



                            <div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
                                        <h3 style={{ margin: 0 }}>Список слотов</h3>
                                        <button
                                            type="button"
                                            className="btn_admin"
                                            onClick={openAssignModal}
                                            disabled={selectedSlotIds.length === 0}
                                            title={
                                                selectedSlotIds.length === 0
                                                    ? 'Выберите один или несколько слотов на карточках ниже'
                                                    : `Назначить ведущего на ${selectedSlotIds.length} слот(ов)`
                                            }
                                            style={{
                                                border: 'none',
                                                cursor: selectedSlotIds.length === 0 ? 'not-allowed' : 'pointer',
                                                backgroundColor: selectedSlotIds.length === 0 ? '#d0d0d0' : '#48b8c7',
                                                color: selectedSlotIds.length === 0 ? '#666' : '#fff',
                                                fontWeight: selectedSlotIds.length === 0 ? 'normal' : 600,
                                                boxShadow:
                                                    selectedSlotIds.length === 0
                                                        ? 'none'
                                                        : '0 0 0 2px rgba(72, 184, 199, 0.45), 0 2px 8px rgba(72, 184, 199, 0.35)',
                                                transition: 'background-color 0.15s, box-shadow 0.15s',
                                            }}
                                        >
                                            Назначить ведущего
                                        </button>
                                    </div>
                                    <label style={{ fontSize: '14px', cursor: 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            checked={showPastSlots}
                                            onChange={() => setShowPastSlots(prev => !prev)}
                                            style={{ marginRight: '6px' }}
                                        />
                                        Показать прошлые
                                    </label>
                                </div>

                                <div
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                        gap: 16,
                                    }}
                                >
                                {slots
                                    .filter(slot => showPastSlots || new Date(slot.datetime) >= new Date())
                                    .map((slot) => {
                                        const weekdayOptions = {
                                            weekday: 'long',
                                            day: '2-digit',
                                            month: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        };
                                        const dateObj = new Date(slot.datetime);
                                        const formattedDate = dateObj.toLocaleString('ru-RU', weekdayOptions);
                                        const dayOfWeek = dateObj.getDay();
                                        const color = weekdayColors[dayOfWeek] || 'black';
                                        const ankets = slot.ankets || [];

                                        // Заполняем до 4-х анкет
                                        const anketsWithPlaceholders = [...ankets];
                                        while (anketsWithPlaceholders.length < 4) {
                                            anketsWithPlaceholders.push(null);
                                        }

                                        const isPast = new Date(slot.datetime) < new Date();
                                        const isSelected = selectedSlotIds.includes(slot.id);
                                        const hidden = slot.slot_status === 'hidden';

                                        return (
                                            <div
                                                key={slot.id}
                                                role="presentation"
                                                onClick={() => toggleSlotSelected(slot.id)}
                                                style={{
                                                    padding: '12px',
                                                    border: isSelected ? '3px solid #48b8c7' : '1px solid #ccc',
                                                    borderRadius: 8,
                                                    background: hidden ? '#f5f5f5' : '#fff',
                                                    cursor: 'pointer',
                                                    boxSizing: 'border-box',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'flex-start',
                                                        marginBottom: '8px',
                                                        gap: 8,
                                                        flexWrap: 'wrap',
                                                    }}
                                                >
                                                    <div style={{ fontWeight: 'bold', color }}>{formattedDate}</div>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => { e.stopPropagation(); setSelectedSlot(slot); }}
                                                        style={{
                                                            backgroundColor: '#4CAF50',
                                                            color: 'white',
                                                            border: 'none',
                                                            padding: '6px 12px',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        Создать презентацию
                                                    </button>
                                                </div>

                                                <div
                                                    style={{ marginBottom: 8, fontSize: 13, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={hidden}
                                                            onChange={(e) => toggleSlotHidden(slot, e)}
                                                        />
                                                        {hidden ? 'Скрыт от пользователей' : 'Открыт для записи'}
                                                    </label>
                                                    {slot.admin_login && (
                                                        <span style={{ color: '#555' }}>Ведущий: {slot.admin_login}</span>
                                                    )}
                                                </div>

                                                {anketsWithPlaceholders.map((anketa, idx) => {
                                                    if (anketa) {
                                                        return (
                                                            <div
                                                                key={anketa.id || idx}
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    padding: '6px 0',
                                                                    borderBottom: '1px dashed #eee',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'flex-start'
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <div>{anketa.fullName || '(без имени)'}</div>

                                                                {isPast ? (
                                                                    <>
                                                                        <div
                                                                            style={{
                                                                                fontSize: '14px',
                                                                                fontWeight: 'bold',
                                                                                color: '#333',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            onClick={() => {
                                                                                handleClickAnket(anketa)
                                                                            }}
                                                                        >
                                                                            Анкета
                                                                        </div>
                                                                        <div
                                                                            style={{
                                                                                fontSize: '13px',
                                                                                color: anketa.feedback ? 'green' : 'red',
                                                                                marginTop: '2px'
                                                                            }}
                                                                        >
                                                                            {anketa.feedback
                                                                                ? `Отзыв оставлен: ${anketa.feedback}`
                                                                                : 'Отзыв не оставлен'}
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <div
                                                                        style={{
                                                                            fontSize: '14px',
                                                                            color: anketa.status === 'filled' ? 'purple' : 'orange',
                                                                            fontWeight: 'bold',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        onClick={() => handleClickAnket(anketa)}
                                                                    >
                                                                        {anketa.status === 'filled' ? 'Анкета заполнена' : 'Анкета заполняется'}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    } else {
                                                        return (
                                                            <div
                                                                key={`placeholder-${idx}`}
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    padding: '6px 0',
                                                                    borderBottom: '1px dashed #eee'
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <div>---</div>
                                                                <div
                                                                    style={{
                                                                        fontSize: '14px',
                                                                        color: 'green',
                                                                        fontWeight: 'bold',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    onClick={() => handleBookAnketaClick(slot)}
                                                                >
                                                                    Анкета свободна
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                })}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div style={{ marginTop: '20px' }}>
                                    {!showAddInput ? (
                                        <button type="button" className='btn_admin' onClick={() => setShowAddInput(true)}>Добавить</button>
                                    ) : (
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <input
                                                type="date"
                                                value={newSlotDate}
                                                onChange={(e) => setNewSlotDate(e.target.value)}
                                            />
                                            <button
                                                className='btn_admin'
                                                onClick={async () => {
                                                    try {
                                                        await createSlots(newSlotDate);
                                                        alert('Слоты созданы');
                                                        setShowAddInput(false);
                                                        setNewSlotDate('');
                                                        // Обновляем список слотов
                                                        getAllSlots()
                                                            .then((data) => {
                                                                const slotsWithFormattedDate = data.slots.map((slot) => ({
                                                                    ...slot,
                                                                    formattedDate: formatDate(slot.datetime),
                                                                }));
                                                                console.log('slotsWithFormattedDate', slotsWithFormattedDate)
                                                                setSlots(slotsWithFormattedDate);
                                                            })
                                                            .catch(console.error);
                                                    } catch (error) {
                                                        alert(error.message);
                                                    }
                                                }}
                                            >
                                                Ок
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <AnketaModal
                                    anketa={modalAnketa}
                                    onClose={handleCloseAnket}
                                    photosArr={photosArr}
                                    setPhotosArr={setPhotosArr}
                                />

                            </div>

                            {assignModalOpen && (
                                <div
                                    className="modal-overlay"
                                    style={{ zIndex: 1000 }}
                                    onClick={() => !assignSaving && setAssignModalOpen(false)}
                                >
                                    <div
                                        className="modal-content-media"
                                        onClick={(e) => e.stopPropagation()}
                                        style={{ maxWidth: 420 }}
                                    >
                                        <h4 style={{ marginBottom: 12 }}>Назначить ведущего</h4>
                                        <p style={{ fontSize: 14, color: '#666', marginBottom: 12 }}>
                                            Выбрано слотов: {selectedSlotIds.length}
                                        </p>
                                        <select
                                            value={selectedLeaderId}
                                            onChange={(e) => setSelectedLeaderId(e.target.value)}
                                            style={{ width: '100%', padding: 8, marginBottom: 16 }}
                                        >
                                            <option value="">— Выберите ведущего —</option>
                                            {leaders.map((l) => (
                                                <option key={l.id} value={l.id}>{l.login}</option>
                                            ))}
                                        </select>
                                        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                                            <button
                                                type="button"
                                                className="btn_anketa"
                                                style={{ background: '#999' }}
                                                disabled={assignSaving}
                                                onClick={() => setAssignModalOpen(false)}
                                            >
                                                Отмена
                                            </button>
                                            <button
                                                type="button"
                                                className="btn_anketa"
                                                disabled={assignSaving}
                                                onClick={confirmAssign}
                                            >
                                                {assignSaving ? 'Сохранение…' : 'ОК'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </>

                    }


                    {activeTab === 'media' && <Media />}
                    {activeTab === 'hosts' && <Hosts />}

                    {activeTab === 'users' && (
                        <div>
                            {/* <h3>Список пользователей</h3>
                            {users.map((user) => (
                                <div
                                    key={user.id}
                                    style={{
                                        padding: '8px',
                                        borderBottom: '1px solid #eee',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '30px',
                                        justifyContent: 'space-between',
                                        width: '50vw'
                                    }}
                                >
                                    
                                    <strong style={{ flex: 1 }}>{user.name || 'Без имени'}</strong> — {user.email}
                                    <p style={{ flex: 1 }}>{user.phone}</p>

                                    <button
                                        onClick={() => handleBlockUser(user.id)}
                                        style={{
                                            marginTop: '4px',
                                            padding: '4px 8px',
                                            backgroundColor: '#e74c3c',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            flex: 1
                                        }}
                                    >
                                        Заблокировать
                                    </button>
                                </div>
                            ))} */}
                            <h3>Список пользователей</h3>
                            {users.map((user) => {
                                const isBlocked = user.status === 'block';

                                return (
                                    <div
                                        key={user.id}
                                        style={{
                                            padding: '8px',
                                            borderBottom: '1px solid #eee',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '30px',
                                            justifyContent: 'space-between',
                                            width: '50vw'
                                        }}
                                    >
                                        <strong style={{ flex: 1 }}>{user.name || 'Без имени'}</strong> — {user.email}
                                        <p style={{ flex: 1 }}>{user.phone}</p>

                                        {isBlocked ? (
                                            <>
                                                <span style={{ fontSize: '20px', color: 'gray' }}>🔒</span>
                                                <button
                                                    onClick={() => handleUnblockUser(user.id)}
                                                    style={{
                                                        marginTop: '4px',
                                                        padding: '4px 8px',
                                                        backgroundColor: '#2ecc71',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        flex: 1
                                                    }}
                                                >
                                                    Разблокировать
                                                </button>
                                            </>
                                        ) : (
                                            <button
                                                onClick={() => handleBlockUser(user.id)}
                                                style={{
                                                    marginTop: '4px',
                                                    padding: '4px 8px',
                                                    backgroundColor: '#e74c3c',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer',
                                                    flex: 1
                                                }}
                                            >
                                                Заблокировать
                                            </button>
                                        )}
                                    </div>
                                );
                            })}

                        </div>
                    )}

                </div>
            }
        </>
    );
};

export default Admin;
